import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "h-full text-gray-900 lg:space-y-7 lg:text-lg" }
const _hoisted_2 = { class: "flex justify-center px-6 mb-2 lg:px-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-5 h-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
  })
], -1)
const _hoisted_4 = { class: "pl-2" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-5 h-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
  })
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", { class: "pl-2" }, " Home ", -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "w-5 h-5"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M4.098 19.902a3.75 3.75 0 0 0 5.304 0l6.401-6.402M6.75 21A3.75 3.75 0 0 1 3 17.25V4.125C3 3.504 3.504 3 4.125 3h5.25c.621 0 1.125.504 1.125 1.125v4.072M6.75 21a3.75 3.75 0 0 0 3.75-3.75V8.197M6.75 21h13.125c.621 0 1.125-.504 1.125-1.125v-5.25c0-.621-.504-1.125-1.125-1.125h-4.072M10.5 8.197l2.88-2.88c.438-.439 1.15-.439 1.59 0l3.712 3.713c.44.44.44 1.152 0 1.59l-2.879 2.88M6.75 17.25h.008v.008H6.75v-.008Z"
  })
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("a", { class: "pl-2" }, " Competition ", -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "w-5 h-5"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M16.5 18.75h-9m9 0a3 3 0 013 3h-15a3 3 0 013-3m9 0v-3.375c0-.621-.503-1.125-1.125-1.125h-.871M7.5 18.75v-3.375c0-.621.504-1.125 1.125-1.125h.872m5.007 0H9.497m5.007 0a7.454 7.454 0 01-.982-3.172M9.497 14.25a7.454 7.454 0 00.981-3.172M5.25 4.236c-.982.143-1.954.317-2.916.52A6.003 6.003 0 007.73 9.728M5.25 4.236V4.5c0 2.108.966 3.99 2.48 5.228M5.25 4.236V2.721C7.456 2.41 9.71 2.25 12 2.25c2.291 0 4.545.16 6.75.47v1.516M7.73 9.728a6.726 6.726 0 002.748 1.35m8.272-6.842V4.5c0 2.108-.966 3.99-2.48 5.228m2.48-5.492a46.32 46.32 0 012.916.52 6.003 6.003 0 01-5.395 4.972m0 0a6.726 6.726 0 01-2.749 1.35m0 0a6.772 6.772 0 01-3.044 0"
  })
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("a", { class: "pl-2" }, " OGAE ", -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-5 h-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z"
  })
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("a", { class: "pl-2" }, "History ", -1)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-6 h-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
  })
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("a", { class: "pl-2" }, " Rules ", -1)
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-5 h-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z"
  })
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("a", { class: "pl-2" }, "Admin Dashboard", -1)
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-5 h-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
  })
], -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("a", { class: "pl-2" }, "Logout", -1)
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-5 h-5",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M8 9a3 3 0 100-6 3 3 0 000 6zM8 11a6 6 0 016 6H2a6 6 0 016-6zM16 7a1 1 0 10-2 0v1h-1a1 1 0 100 2h1v1a1 1 0 102 0v-1h1a1 1 0 100-2h-1V7z" })
], -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("a", { class: "pl-2" }, "Sign Up", -1)
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "w-5 h-5",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M3 3a1 1 0 011 1v12a1 1 0 11-2 0V4a1 1 0 011-1zm7.707 3.293a1 1 0 010 1.414L9.414 9H17a1 1 0 110 2H9.414l1.293 1.293a1 1 0 01-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("a", { class: "pl-2" }, "Login", -1)
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NominateButton = _resolveComponent("NominateButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_NominateButton)
    ]),
    (_ctx.isLoggedIn)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([_ctx.$route.path == '/profile' ? 'text-white' : 'text-gray-400', "flex items-center px-6 py-2 mb-2 font-medium transition-colors duration-200 rounded whitespace-nowrap lg:py-0 lg:px-0 hover:text-white"]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToProfile && _ctx.goToProfile(...args)))
        }, [
          _hoisted_3,
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.user.userName), 1)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.isLoggedIn)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass([[
        _ctx.$route.path == _ctx.usersCountryPath ? 'text-white ' : 'text-gray-400 ',
        _ctx.user.country.name.length > 24 ? 'text-xs lg:text-sm' : '',
      ], "flex items-center px-6 py-2 mb-2 font-medium transition-colors duration-200 rounded whitespace-nowrap lg:py-0 lg:px-0 hover:text-white"]),
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToUsersCountry && _ctx.goToUsersCountry(...args)))
        }, [
          _createElementVNode("img", {
            class: _normalizeClass([_ctx.$route.path == _ctx.usersCountryPath ? ' border-opacity-100' : 'border-opacity-20 border-1', "object-cover w-5 h-4 border-white rounded-sm border-1"]),
            src: 'https://flagcdn.com/w160/' + _ctx.user.country.icon.toLowerCase() + '.png'
          }, null, 10, _hoisted_5),
          _createElementVNode("p", {
            class: _normalizeClass([_ctx.$route.path == _ctx.usersCountryPath ? 'text-white' : 'text-gray-400', "pl-2 transition-colors duration-200 hover:text-white"])
          }, _toDisplayString(_ctx.user.country.name), 3)
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.$route.path == '/' ? 'text-white' : 'text-gray-400', "flex items-center px-6 py-2 mb-2 font-medium transition-colors duration-200 rounded whitespace-nowrap lg:py-0 lg:px-0 hover:text-white"]),
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args)))
    }, _hoisted_8, 2),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.$route.path.includes('competition') ? 'text-white' : 'text-gray-400', "flex items-center px-6 py-2 mb-2 font-medium transition-colors duration-200 rounded whitespace-nowrap lg:py-0 lg:px-0 hover:text-white"]),
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goToCompetition && _ctx.goToCompetition(...args)))
    }, _hoisted_11, 2),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.$route.path == '/ogae/countries' ? 'text-white' : 'text-gray-400', "cursor-pointer flex items-center px-6 py-2 mb-2 font-medium transition-colors duration-200 rounded whitespace-nowrap lg:py-0 lg:px-0 hover:text-white"]),
      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goToOgae && _ctx.goToOgae(...args)))
    }, _hoisted_14, 2),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.$route.path.includes('/history') ? 'text-white' : 'text-gray-400', "flex items-center px-6 py-2 mb-2 font-medium transition-colors duration-200 rounded whitespace-nowrap lg:py-0 lg:px-0 hover:text-white"]),
      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.goToHistory && _ctx.goToHistory(...args)))
    }, _hoisted_17, 2),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.$route.path == '/rules' ? 'text-white' : 'text-gray-400', "flex items-center px-6 py-2 mb-2 font-medium transition-colors duration-200 rounded whitespace-nowrap lg:py-0 lg:px-0 hover:text-white"]),
      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.goToRules && _ctx.goToRules(...args)))
    }, _hoisted_20, 2),
    (_ctx.isUserAdmin)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass([_ctx.$route.path == '/admin' ? 'text-white' : 'text-gray-400', "flex items-center px-6 py-2 mb-2 font-medium transition-colors duration-200 rounded whitespace-nowrap lg:py-0 lg:px-0 hover:text-white"]),
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.goToAdmin && _ctx.goToAdmin(...args)))
        }, _hoisted_23, 2))
      : _createCommentVNode("", true),
    (_ctx.isLoggedIn)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "flex items-center px-6 py-2 mb-2 font-medium text-gray-400 transition-colors duration-200 rounded whitespace-nowrap lg:py-0 lg:px-0 hover:text-white",
          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.logOut && _ctx.logOut(...args)))
        }, _hoisted_26))
      : _createCommentVNode("", true),
    (!_ctx.isLoggedIn)
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: "flex items-center px-6 py-2 mb-2 font-medium text-gray-400 transition-colors duration-200 rounded whitespace-nowrap lg:py-0 lg:px-0 hover:text-white",
          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.goToSignUp && _ctx.goToSignUp(...args)))
        }, _hoisted_29))
      : _createCommentVNode("", true),
    (!_ctx.isLoggedIn)
      ? (_openBlock(), _createElementBlock("div", {
          key: 5,
          class: "flex items-center px-6 py-2 mb-2 font-medium text-gray-400 transition-colors duration-200 rounded whitespace-nowrap lg:py-0 lg:px-0 hover:text-white",
          onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.goToLogin && _ctx.goToLogin(...args)))
        }, _hoisted_32))
      : _createCommentVNode("", true)
  ]))
}